import { createContext, useContext, ReactNode } from 'react'

type ThemeColor = 'blue' | 'magenta' | 'red'

const ThemeColorContext = createContext<ThemeColor>('blue')

export const ThemeColorProvider = ({
  themeColor,
  children,
}: {
  themeColor: string
  children: ReactNode
}) => {
  return (
    <ThemeColorContext.Provider value={themeColor as ThemeColor}>
      {children}
    </ThemeColorContext.Provider>
  )
}

export const useThemeColor = () => {
  const themeColor = useContext(ThemeColorContext)

  return themeColor
}
